import React, { useEffect } from 'react';
import { useVirtual } from 'react-virtual';
import styled from '@emotion/styled/macro';

import NavigationItem from '../layout/NavigationItem';
import ItemHoverLabelIcons from '../utils/ItemHoverLabelIcons';

const VirtualisedItemList = ({
    items,
    onAutoformCopy,
    itemIndex,
    renderItems,
    onAddToPortfolioModalOpen,
    autoformItemType,
}) => {
    const parentRef = React.useRef();
    const { virtualItems, scrollToIndex, totalSize } = useVirtual({
        size: items.length,
        parentRef: parentRef,
        estimateSize: React.useCallback(() => 40, []),
        overscan: 3,
        paddingStart: 8,
        paddingEnd: 8,
    });

    useEffect(() => {
        scrollToIndex(itemIndex);
    }, [itemIndex, scrollToIndex]);

    return (
        <div ref={parentRef}>
            <ListWrapper height={totalSize}>
                {virtualItems.map((virtualItem) => {
                    return (
                        <StyledNavigationItem
                            scrollStart={virtualItem.start}
                            ref={virtualItem.measureRef}
                            key={virtualItem.index}
                        >
                            {renderItems(virtualItem)}

                            {autoformItemType && (
                                <ItemHoverLabelIcons
                                    onCopy={onAutoformCopy}
                                    selected={items[virtualItem.index]}
                                    onAdd={() => onAddToPortfolioModalOpen(items[virtualItem.index])}
                                />
                            )}
                        </StyledNavigationItem>
                    );
                })}
            </ListWrapper>
        </div>
    );
};

const ListWrapper = styled.ul`
    height: ${(props) => props.height}px;
    position: relative;
`;

const StyledNavigationItem = styled(NavigationItem)`
    position: absolute;
    top: ${(props) => props.scrollStart}px;
    left: 0;
    width: 100%;
    border: 3px solid;
    box-shadow: none !important;
    border-radius: var(--chakra-radii-lg);
    border-color: transparent;

    &:hover,
    &:focus-within {
        // Chakra uses 3px outline shadow with that exact outline color
        border: 3px solid;
        border-color: rgba(66, 153, 225, 0.6);
    }
`;

export default VirtualisedItemList;
